// extracted by css-extract-rspack-plugin
export default {"NavLink":"UJmHZ","NavLinkSection":"OegxB","NavLinkLabel":"h0vSY","NavLinkChevron":"zvCYe"};